import Post from './post';
import React, { useEffect, useState, useCallback } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { getDatabase, ref, set, child, push, update, onValue, get } from "firebase/database";
import { getStorage, ref as sRef } from "firebase/storage";
import { uploadBytes, getDownloadURL } from "firebase/storage";

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {v4} from 'uuid';
import './styles/App.css';
import './styles/chatroom.css';

function Chatroom(props)
{
    const db = getDatabase();
    const storage = getStorage();
    const [chat, setChat] = useState([]);
    const [text, setText] = useState(""); 
    const [modal, setModal] = useState(false);
    const [receiver, setReceiver] = useState("");
    const handleClose = () => setModal(false);
    const handleShow = () => setModal(true);
    const [RWD, setRwd] = useState(false);

    useEffect(() => {
        if(window.innerWidth <= 800)
            setRwd(true);
        else
            setRwd(false);

    }, [window.innerWidth]);
    
    const post = () =>{

        if (text != "") {
            var new_chat = {
                data: text,
                sender: props.user_email,
                type: 0,
                unsend: false,
                notify: false
            };
            
            const db_ref = ref(db, `rooms/${props.room_id}/chats`);
            const new_ref = push(db_ref);
            set(new_ref, new_chat);
        }
        setText("");
    }

    const handle_img = (select) => {
        if (select != null) {
                var img_ref = sRef(storage, `img/${select.name + v4()}`);
                uploadBytes(img_ref, select).then(() => {
                    console.log('Uploaded a blob or file!');
                    getDownloadURL(img_ref).then((url) => {
                        var new_chat = {
                            data: url,
                            sender: props.user_email,
                            type: 1,
                            unsend: false
                        };
                        const db_ref = ref(db, `rooms/${props.room_id}/chats`);
                        const new_ref = push(db_ref);
                        set(new_ref, new_chat);
                    });
                });
                
        }
    }       

    const handle_video = (select) => {
        if(select != null)
        {
            var img_ref = sRef(storage, `img/${select.name + v4()}`);
            uploadBytes(img_ref, select).then(() => {
                console.log('Uploaded a blob or file!');
                getDownloadURL(img_ref).then((url) => {
                    var new_chat = {
                        data: url,
                        sender: props.user_email,
                        type: 2,
                        unsend: false
                    };
                    const db_ref = ref(db, `rooms/${props.room_id}/chats`);
                    const new_ref = push(db_ref);
                    set(new_ref, new_chat);
                });
            });
        }

    }

    const handle_unsend = (id) => {   
        const db_ref = ref(db, `rooms/${props.room_id}/chats`);
        onValue(db_ref, (snapshot) => {
            const data = snapshot.val();
            var cnt = 0;
            Object.keys(data).map((key) => {
                if(cnt == id)
                {
                    var new_ref = ref(db, `rooms/${props.room_id}/chats/${key}`);
                    update(new_ref, {unsend: true});
                }
                cnt = cnt + 1;
            });
         });
        
    }

    const send_notification = (sender) => {
        if('Notification' in window && Notification.permission === 'granted') {
            console.log('sending notification');
            new Notification(`${sender} sent a message !`);
        }
    }
    const request_permission = useCallback(() => {
        if('Notification' in window) {
            Notification.requestPermission()
            .then((result) => {
                console.log(result);
                if(result === 'granted')
                {
                    console.log('permission granted');
                } 
            });
        }
    }, []);

    const handle_image_btn = () => {
        document.querySelector('#image_btn').click();
    }
    const handle_video_btn = () => {
        document.querySelector('#video_btn').click();
    }
    useEffect(() => {
        if('Notification' in window) 
            request_permission();
    }, [request_permission]);

    useEffect(() => {
        console.log("now in room: " + props.room_id);
        const db_ref = ref(db, `rooms/${props.room_id}/chats`);
        onValue(db_ref, (snapshot) => {  
                const data = snapshot.val();
                var new_chat = [];
                Object.keys(data).map((key) => {
                    new_chat.push(data[key]);
                });
                if(new_chat[new_chat.length-1].sender != props.user_email && new_chat[new_chat.length-1].notify == false)
                {   
                    send_notification(new_chat[new_chat.length-1].sender);
                    var new_ref = ref(db, `rooms/${props.room_id}/chats/${Object.keys(data)[Object.keys(data).length-1]}`);
                    update(new_ref, {notify: true});

                }
                    
                setChat(new_chat);
                console.log("new chat: " + new_chat);
            });
         }, [props.room_id]);

    return(
       <div id="right_side">
            <div id="invite_ppl">
                <button  onClick={handleShow} style={{border: "none", backgroundColor: "burlywood"}}>
                    <img id="invite_btn" src="./img/invite.png" alt="user" />
                </button>
                <Modal show={modal} onHide={handleClose}>
                    <Modal.Header closeButton>
                    <Modal.Title> Invite more friends to chat !</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h5 className="border-bottom border-gray pb-2 mb-0">Invite Who</h5>
                        <textarea className="form-control" rows="5" id="invite_ppl" style={{ resize:null }} value={receiver} onInput={(e) => {setReceiver(e.target.value)}} ></textarea>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={() => {props.handle_invite(receiver, props.room_id); setReceiver(""); setModal(false);}}>
                            Invite
                        </Button>
                    </Modal.Footer>
                </Modal>    
            </div>

            <div id="chat_list">
                <Post msg={chat} user_email={props.user_email} handle_unsend={handle_unsend} RWD={RWD}/>
            </div>

            <div id="send" style={{display: 'flex', marginTop: 30}}>
                <button onClick={handle_image_btn} style={{marginLeft: 10, marginRight: 10, border: "none", backgroundColor: "burlywood"}}>
                    <img src="./img/image.png" alt="user" style={{height: 64 , width:64}}/>
                </button>
                <button onClick={handle_video_btn} style={{marginLeft: 10, border: "none", backgroundColor: "burlywood"}}>
                    <img src="./img/youtube.png" alt="user" style={{height: 64 , width:64}} />
                </button>
                <input id="image_btn" type="file"  onChange={(e) =>{handle_img(e.target.files[0])}} ></input>
                <input id="video_btn" type="file" onChange={(e) =>{handle_video(e.target.files[0])}}></input>
                <FloatingLabel controlId="floatingTextarea" label="Message" className="mb-3" style={{marginLeft: 50, width: "50%"}}>
                    <Form.Control as="textarea" placeholder="Leave a message" value={text} onInput={(e) => {setText(e.target.value)}}/>
                </FloatingLabel>
                <div className="media text-muted pt-3">
                    <button id="post_btn" type="button" className="btn btn-success" onClick ={() => post(0)} style={{border: "none", backgroundColor: "burlywood"}}>
                        <img  src="./img/send.png" alt="user" />
                    </button>
                </div>
            </div>
       </div>
    );
}
export default Chatroom;